import React from "react";
export const GuillemetHautGauche = ({ color, size, info }) => (
	<svg className={info} viewBox="0 0 15 15" width={size} height={size}>
		<path fill={color} d="M12,0H3C2.9,0,2.8,0,2.7,0C2.6,0,2.6,0,2.5,0C1.8,0,1.3,0.3,0.8,0.8C0.3,1.3,0,1.8,0,2.5c0,0.1,0,0.1,0,0.2C0,2.8,0,2.9,0,3v9c0,1.6,1.1,3,2.5,3S5,13.6,5,12V5h7c1.6,0,3-1.1,3-2.5S13.6,0,12,0z" />
	</svg>
)